// https://vuex.vuejs.org/en/mutations.html



export default {
  setWhiteLabel (state, payload) {
    state.whitelabel = payload;
    localStorage.setItem("current-whitelabel", payload.name);
  },
};
 